module.exports = __webpack_public_path__ + "static/media/fww.27ab27b5.png";